<!-- Note: there was previously an upsell element here with an ngIf to control display -->
<div class="wrapper free">
	<div class="list-wrapper">
		<img class="check-icon" [src]="'./assets/Ringing Phone (Navy).svg' | resolveAsset" alt="" />
		<p class="title">Need urgent help? <br />Call us at (610) 686-7778</p>
	</div>
	<p class="light">Available 9 AM - 5 PM EST</p>
</div>
